import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Sites from './pages/Sites';
import SiteDetail from './pages/SiteDetail';
import Deployments from './pages/Deployments';
import DNS from './pages/DNS';
import Databases from './pages/Databases';
import { Help } from './pages/Help';
import Settings from './pages/Settings';
import Login from './pages/Login';
import HealthDashboard from './pages/HealthDashboard';
import HealthAccounts from './pages/HealthAccounts';
import HealthAccountDetail from './pages/HealthAccountDetail';
import HealthSubscriptions from './pages/HealthSubscriptions';
import HealthAuditLog from './pages/HealthAuditLog';

interface User {
  id: string;
  username: string;
  email: string | null;
  avatarUrl: string | null;
  isAdmin: boolean;
}

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    fetch('/api/auth/me')
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error('Not authenticated');
      })
      .then((data) => {
        setUser(data);
        setLoading(false);
      })
      .catch(() => {
        setUser(null);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <Layout user={user}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/sites" element={<Sites />} />
        <Route path="/sites/:id" element={<SiteDetail />} />
        <Route path="/deployments" element={<Deployments />} />
        <Route path="/dns" element={<DNS />} />
        <Route path="/databases" element={<Databases />} />
        <Route path="/health" element={<HealthDashboard />} />
        <Route path="/health/accounts" element={<HealthAccounts />} />
        <Route path="/health/accounts/:id" element={<HealthAccountDetail />} />
        <Route path="/health/subscriptions" element={<HealthSubscriptions />} />
        <Route path="/health/audit" element={<HealthAuditLog />} />
        <Route path="/help" element={<Help />} />
        <Route path="/settings" element={<Settings user={user} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
